import React, { createContext, useContext } from 'react';

const UploadContext = createContext(null);

export const UploadProvider = ({ children, fileUploadRef }) => {
  const triggerUpload = () => {
    if (fileUploadRef?.current) {
      const input = fileUploadRef.current.querySelector('input[type="file"]');

      if (input) {
        input.click();
      }
    }
  };

  return (
    <UploadContext.Provider value={{ triggerUpload }}>
      {children}
    </UploadContext.Provider>
  );
};

export const useUpload = () => {
  const context = useContext(UploadContext);
  if (!context) {
    throw new Error('useUpload must be used within UploadProvider');
  }
  return context;
};
